//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilterForm from './FilterForm.vue';

export default {
  components: {
    FilterForm,
  },
  props: {
    title: String,
    description: String,
  },
  data() {
    return {
      isCalloutVisible: false,
      sizeAttribute: '',
    };
  },
  mounted() {
    // Attach event listeners to update the div attribute based on screen size changes
    const mediaQueries = {
      sm: window.matchMedia('(max-width: 576px)'),
      md: window.matchMedia('(min-width: 577px)'),
    };

    Object.keys(mediaQueries).forEach(size => {
      mediaQueries[size].addListener(event => {
        if (event.matches) {
          this.sizeAttribute = size.toUpperCase();
        }
      });

      // Initially update the attribute based on the current screen size
      if (mediaQueries[size].matches) {
        this.sizeAttribute = size.toUpperCase();
      }
    });

    // Set up the Intersection Observer
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '0px',
      threshold: 0.5, // Ratio of element's visibility needed to trigger callback
    };

    const observer = new IntersectionObserver(this.handleIntersection, options);

    // Start observing the callout element
    const calloutElement = this.$refs.calloutDiv;
    observer.observe(calloutElement);
  },
  methods: {
    handleIntersection(entries) {
      // Callback function when intersection changes
      const isVisible = entries[0].isIntersecting;
      this.isCalloutVisible = isVisible;
    },
  },
};
